import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

export default class extends Controller {
  connect() {
    if (window.location.hash === this.element.dataset.bsTarget) {
      Tab.getOrCreateInstance(this.element).show()
      // Scroll to top of window
      setTimeout(() => {
        window.scrollTo(0, 0)
        document.activeElement?.blur()
      }, 100)
    }
  }

  activate() {
    // Update the location hash when the tab is clicked
    history.replaceState(null, "", `${window.location.pathname}${this.element.hash}`)
  }
}
